import React from 'react';
import '../styles.css';

const ContactForm = () => {
  return (
    <div className="contact-form-container">
      <h1 className="contact-header">Get in Touch</h1>
      <div className="social-links">
        <a href="mailto:minya@g.ucla.edu" className="social-links">
          <div className="circle-text">
            <div className="circle-border">
              <img src="images/home_page/mail-vector.svg" alt="Mail"/>
            </div>
          <p>email</p>
          </div>
        </a>
        <a href="https://www.linkedin.com/in/miaminyaliu/" target="_blank" rel="noopener noreferrer" className="social-links">
        <div className="circle-text">
          <div className="circle-border">
            <img src="images/home_page/linkedin-vector.svg" alt="LinkedIn"/> 
          </div>
          <p>linkedin</p>
        </div>
        </a>
        <a href="https://www.instagram.com/minya.liu/" target="_blank" rel="noopener noreferrer" className="social-links">
          <div className="circle-text">
            <div className="circle-border">
              <img src="images/home_page/instagram-vector.svg" alt="Instagram"/>
            </div>
          <p>instagram</p>
          </div>
        </a>
      </div>
    </div>
  );
};

export default ContactForm;